import React from "react";
import { FaStar } from "react-icons/fa";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah M.",
      location: "Leicester",
      text: "The bioresonance therapy has been life-changing for my chronic pain. The team's expertise and EU-certified equipment gave me confidence from day one.",
      rating: 5
    },
    {
      name: "James R.",
      location: "Nottingham",
      text: "After trying many treatments, bioresonance therapy finally helped with my allergies. The CMA certification and professional approach made all the difference.",
      rating: 5
    },
    {
      name: "Emma L.",
      location: "Derby",
      text: "The mental health support and addiction therapy programs are exceptional. Their 7+ years of experience really shows in their approach.",
      rating: 5
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-white via-gold/5 to-blue/5">
      <div className="container mx-auto px-4">
        {/* Testimonials Section */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-dark-grey mb-4" style={{ fontFamily: "Playfair Display, serif" }}>
              What Our Clients Say
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Real experiences from people who have trusted us with their health and wellness
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="group relative">
                <div className="relative p-4">
                  <div className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 border border-grey/20 h-full relative overflow-hidden group-hover:scale-105">
                    {/* Animated Background Gradient */}
                    <div className="absolute inset-0 bg-gradient-to-br from-gold/5 via-transparent to-blue/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    
                    {/* Content */}
                    <div className="relative z-10">
                      {/* Stars */}
                      <div className="flex justify-center mb-4">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <FaStar key={i} className="text-gold text-lg" />
                        ))}
                      </div>
                      
                      {/* Quote */}
                      <p className="text-gray-600 text-center leading-relaxed mb-6 italic">
                        "{testimonial.text}"
                      </p>
                      
                      {/* Author */}
                      <div className="text-center">
                        <div className="font-semibold text-dark-grey">{testimonial.name}</div>
                        <div className="text-sm text-gray-500">{testimonial.location}</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Enhanced Creative Borders */}
                  <div className="absolute inset-0 border-4 border-gold/40 rounded-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-700 shadow-xl"></div>
                  <div className="absolute inset-3 border-2 border-white/60 rounded-2xl transform -rotate-1 group-hover:rotate-0 transition-transform duration-500"></div>
                </div>
                
                {/* Floating Elements */}
                <div className="absolute top-4 right-4 w-2 h-2 bg-gradient-to-r from-gold to-yellow rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100 shadow-lg animate-pulse"></div>
                <div className="absolute bottom-4 left-4 w-1 h-1 bg-gradient-to-r from-blue to-purple rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-200 shadow-lg animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;

